<template>
  <div v-if="!isDraft && hasAtLeastOneSection">
    <CSidebarNavTitle v-translate>Insights</CSidebarNavTitle>
    <template v-if="canSeeOrders">
      <CSidebarNavItem
          :name="$gettext('Orders')"
          :to="ordersRoute"
          icon="cip-order"/>
    </template>
    <template v-if="canSeePrinter">
      <CSidebarNavItem
          :name="$gettext('Print Orders')"
          :to="{name: 'edgePrintOrderList', params: {picaServiceId: picaServiceId}}"
          icon="cipOrder"/>
      <CSidebarNavItem
          :name="$gettext('Print Jobs')"
          :to="{name: 'edgePrintJobList', params: {picaServiceId: picaServiceId}}"
          icon="cilPrint"/>
    </template>
    <template v-if="canSeeConsolidate">
    <CSidebarNavItem
        :name="$gettext('Closing balance')"
        :to="{name: 'yearlyConsolidation', params: {picaServiceId: picaServiceId}}"
        icon="cip-calendar"/>
    </template>
    <template v-if="hasPerm('stats.analytics')">
      <CSidebarNavItem
          :name="$gettext('Analytics')"
          :to="{name: 'stats', params: {picaServiceId: picaServiceId}}"
          icon="cip-stats"
      />
    </template>
    <template v-if="hasPerm('checkin.list')">
      <CSidebarNavItem
          :name="$gettext('Check-ins')"
          :to="{name: 'checkin.list', params: {picaServiceId: picaServiceId}}"
          icon="cip-user-square"
      />
    </template>
  </div>
</template>

<script>


import {mapGetters} from "vuex";

export default {
  name: 'InsightNav',
  computed: {
    ...mapGetters('event', [
      'picaServiceId',
      'isDraft',
      'isResort',
      'industry',
      'isEdge',
    ]),
    ...mapGetters('features', [
      'isPrintersEnabled'
    ]),
    canSeeConsolidate() {
      return this.hasPerm('consolidation.list')
    },
    canSeeOrders() {
      return this.hasPerm('event_wizard.see_orders')
    },
    canSeePrinter() {
      return this.isPrintersEnabled && this.hasPerm('event_wizard.see_printer')
    },
    hasAtLeastOneSection() {
      return this.canSeeOrders
          || this.canSeePrinter
          || this.canSeeConsolidate
          || this.hasPerm('stats.analytics')
          || this.hasPerm('checkin.list')
    },
    ordersRoute() {
      // Route to edge orders if is_edge is true, otherwise to normal orders
      if (this.isEdge) {
        return { name: 'edgeOrderList', params: { picaServiceId: this.picaServiceId } }
      } else {
        return { name: 'eventOrderList', params: { picaServiceId: this.picaServiceId } }
      }
    }
  }
}
</script>
